import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../config';
import { AppLink, routeNaming, AppRedirect } from '../../routes';
import { HomeNavbar } from '../../common/home-navbar';
import { InstallationForm } from '../../common/installation-form';
import { SecondaryButton } from '../../common/secondary-button';
import { Modal } from '../../common/modal';
import { Spinner } from '../../common/spinner';
import { IndividualCheckoutStore } from './stores/IndividualCheckoutStore';
import { InstallationStore } from '../../stores/InstallationStore';
import styles from './InstallationCoordination.css';

const IPropTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      checkoutId: PropTypes.string.isRequired,
      productId: PropTypes.isRequired,
    }).isRequired,
  }).isRequired,
};

class InstallationCoordination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidAddress: false,
      coordinationSuccess: false,
      noCoordinations: false,
    };

    this._onInvalidAddress = this._onInvalidAddress.bind(this);
    this._onCoordinationSuccess = this._onCoordinationSuccess.bind(this);
  }

  componentDidMount() {
    InstallationStore.clearCoordinationData();
    IndividualCheckoutStore.findCheckout(this.props.match.params.checkoutId);
  }

  _buildCart(checkout) {
    return checkout.cart.map((item) => {
      if (!item.product.id === this.props.match.params.productId) {
        return null;
      }
      const installationData = checkout.installationData.find(data => (
        data.productId === item.product.id
      ));
      const selectedInstallations = !installationData ?
        0 :
        installationData.selectedOptions.reduce((acc, data) => (
          acc + data.amount
        ), 0);
      return {
        product: item.product,
        serviceAmount: item.serviceAmount - selectedInstallations,
      };
    }).filter(item => item && item.serviceAmount);
  }

  _onInvalidAddress() {
    this.setState({
      invalidAddress: true,
    });
  }

  async _onCoordinationSuccess(installations) {
    const cart = this._buildCart(IndividualCheckoutStore.checkout);
    const installationsWithAddedInfo = installations.map((data) => {
      const item = cart.find(cartItem => cartItem.product.id === data.productId);
      const selectedInstallations = data.selectedOptions.reduce((acc, option) => (
        acc + option.amount
      ), 0);
      return {
        ...data,
        remainingInstallations: item.serviceAmount - selectedInstallations,
      };
    }).filter(data => data.selectedOptions.length);
    if (installationsWithAddedInfo.length) {
      await InstallationStore.coordinateInstallation(
        IndividualCheckoutStore.checkout.id,
        installationsWithAddedInfo,
      );
    }
    if (!installationsWithAddedInfo.length) {
      this.setState({
        noCoordinations: true,
      });
    } else if (!InstallationStore.coordinationError) {
      this.setState({
        coordinationSuccess: true,
      });
    }
  }

  render() {
    const { checkout } = IndividualCheckoutStore;
    let startDate = new Date();
    if (checkout && checkout.shippingData) {
      const shippingDate = checkout.shippingData.date.toJSDate();
      if (startDate.getTime() < shippingDate.getTime()) {
        startDate = shippingDate;
      }
    }
    let cart = null;
    if (checkout) {
      cart = this._buildCart(checkout);
    }
    return (
      <div className={styles.container}>
        <HomeNavbar />
        <div className={styles.internalContainer}>
          <h1 className={styles.title}>
            Coordinación de instalaciones
          </h1>
          {
            IndividualCheckoutStore.loading &&
            <Spinner className={styles.spinner} />
          }
          {
            (IndividualCheckoutStore.error ||
            InstallationStore.coordinationError) &&
            <div className={styles.messageContainer}>
              <p className={styles.messageText}>
                Parece que estamos experimentando un error. Intente nuevamente.
              </p>
              <AppLink
                routeName={routeNaming.MY_ORDERS}
              >
                <SecondaryButton
                  className={styles.messageButton}
                >
                  Volver a mis pedidos
                </SecondaryButton>
              </AppLink>
            </div>
          }
          {
            !!checkout &&
            !!cart.length &&
            !this.state.coordinationSuccess &&
            !InstallationStore.coordinationError &&
            <InstallationForm
              addressId={checkout.address.id}
              cart={cart}
              startDate={startDate}
              onInvalidAddress={this._onInvalidAddress}
              onSubmit={this._onCoordinationSuccess}
            />
          }
          {
            this.state.noCoordinations &&
            <AppRedirect routeName={routeNaming.MY_ORDERS} />
          }
          {
            this.state.invalidAddress &&
            <Modal>
              <div className={styles.modalContainer}>
                <p className={styles.modalText}>
                  Lamentablemente no realizamos instalaciones a esa dirección. Por favor
                  comuníquese al {constants.contactPhoneNumber.text}.
                </p>
                <AppLink
                  routeName={routeNaming.MY_ORDERS}
                >
                  <SecondaryButton
                    className={styles.modalButton}
                  >
                    Volver a mis pedidos
                  </SecondaryButton>
                </AppLink>
              </div>
            </Modal>
          }
          {
            this.state.coordinationSuccess &&
            <div className={styles.messageContainer}>
              <p className={styles.messageText}>
                Su coordinación ha sido guardada exitosamente.
              </p>
              <AppLink
                routeName={routeNaming.MY_ORDERS}
              >
                <SecondaryButton
                  className={styles.messageButton}
                >
                  Volver a mis pedidos
                </SecondaryButton>
              </AppLink>
            </div>
          }
          {
            !!checkout &&
            !cart.length &&
            <div className={styles.messageContainer}>
              <p className={styles.messageText}>
                No hay instalaciones pendientes para este pedido
              </p>
              <AppLink
                routeName={routeNaming.MY_ORDERS}
              >
                <SecondaryButton
                  className={styles.messageButton}
                >
                  Volver a mis pedidos
                </SecondaryButton>
              </AppLink>
            </div>
          }
        </div>
      </div>
    );
  }
}

InstallationCoordination.propTypes = IPropTypes;

const ObservedInstallationCoordination = observer(InstallationCoordination);

export { ObservedInstallationCoordination as InstallationCoordination };



// WEBPACK FOOTER //
// ./src/pages/installation-coordination/InstallationCoordination.jsx